import { Box, Container, Typography, Button, Stack, Chip } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import VerifiedIcon from '@mui/icons-material/Verified';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { CITIES } from '../data/constants';
import { GOLD, GOLD2, GOLDF, DARK } from '../theme/theme';
import ScrollReveal from './ScrollReveal';

export default function CityBoxes({ onEnquire }) {
  return (
    <Box id="projects" sx={{
      scrollMarginTop: '117px',
      bgcolor: '#ffffff',
      py: { xs: 6, md: 9 },
      borderTop: '1px solid rgba(0,0,0,0.06)',
    }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 4 } }}>
        <ScrollReveal>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography sx={{ fontSize: '11px', color: GOLD, fontWeight: 700, letterSpacing: '0.30em', textTransform: 'uppercase', mb: 1 }}>
              — OUR PRESENCE —
            </Typography>
            <Typography variant="h3" sx={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.2rem' }, color: DARK, mb: 1 }}>
              We Are Present Across{' '}
              <Box component="span" sx={{ color: GOLD }}>6 Prime Locations</Box>
            </Typography>
            <Typography sx={{ fontSize: '14px', color: '#777' }}>Choose the perfect location for your future.</Typography>
          </Box>
        </ScrollReveal>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(3,1fr)' }, gap: 3 }}>
          {CITIES.map((city, i) => (
            <ScrollReveal key={city.name} delay={i * 90}>
              <Box sx={{
                bgcolor: '#fff', borderRadius: '14px', overflow: 'hidden',
                boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
                border: '1px solid rgba(0,0,0,0.07)',
                transition: 'transform 0.28s cubic-bezier(0.22,1,0.36,1), box-shadow 0.28s ease, border-color 0.28s',
                '&:hover': { transform: 'translateY(-7px)', boxShadow: '0 12px 36px rgba(0,0,0,0.16)', borderColor: GOLD },
                '&:hover .city-card-img': { transform: 'scale(1.08)' },
              }}>
                <Box sx={{ position: 'relative', height: 190, overflow: 'hidden' }}>
                  <Box component="img" src={city.img} alt={city.name} className="city-card-img"
                    sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.6s ease' }} />
                  <Chip
                    icon={<LocationOnIcon sx={{ fontSize: '12px !important', color: '#fff !important' }} />}
                    label={city.tag} size="small"
                    sx={{ position: 'absolute', top: 12, left: 12, bgcolor: GOLD, color: '#fff', fontWeight: 700, fontSize: '10px', letterSpacing: '0.05em', height: 24 }}
                  />
                </Box>
                <Box sx={{ p: 2.5 }}>
                  <Typography sx={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 700, fontSize: '1.1rem', color: DARK, mb: 0.3 }}>{city.name}</Typography>
                  <Typography sx={{ fontSize: '12px', color: '#888', mb: 1.2, fontStyle: 'italic' }}>{city.tagline}</Typography>
                  <Typography sx={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 900, fontSize: '1.2rem', color: GOLD, mb: 0.8 }}>{city.price}</Typography>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <HomeWorkIcon sx={{ fontSize: 13, color: '#888' }} />
                      <Typography sx={{ fontSize: '11px', color: '#666' }}>{city.plots}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                      <VerifiedIcon sx={{ fontSize: 13, color: '#1a6b3a' }} />
                      <Typography sx={{ fontSize: '10px', color: '#1a6b3a', fontWeight: 700 }}>{city.badge}</Typography>
                    </Box>
                  </Stack>
                  <Button fullWidth onClick={onEnquire} endIcon={<ArrowForwardIcon />} sx={{
                    bgcolor: DARK, color: GOLDF, fontWeight: 700, fontSize: '12px', py: 1.1, borderRadius: '8px',
                    transition: 'all 0.22s ease',
                    '&:hover': { bgcolor: '#1a1000', color: '#fff8c0', transform: 'scale(1.02)' },
                  }}>
                    View Project
                  </Button>
                </Box>
              </Box>
            </ScrollReveal>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
